import { render, staticRenderFns } from "./DialogCreateCustomList.vue?vue&type=template&id=a8b06f46"
import script from "./DialogCreateCustomList.vue?vue&type=script&lang=js"
export * from "./DialogCreateCustomList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports